import { format } from "date-fns";

export default {
  formatDate: (date: string, formatDate?: string): string => {
    if (date !== "") {
      return format(new Date(date), formatDate || "DD/MM/YYYY");
    } else {
      return "-";
    }
  },
  formatISODate: (date: string): string => {
    if (date !== "") {
      return new Date(date).toISOString();
    } else {
      return "-";
    }
  },
  getCurrentYear: (): number => {
    return new Date().getFullYear();
  },

  formatSingaporeDateTime: (date: string, suffix?: string): string => {
    if (!date) {
      return "-";
    }
    const d = new Date(date);

    const datePart = d.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: "Asia/Singapore"
    });

    const timePart = d.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "Asia/Singapore"
    });

    return `${datePart} ${timePart}${suffix ? " " + suffix : ""}`;
  }
};
